export default __webpack_public_path__ + "static/personal-loan-3x-dd1b66df90ba7d9c05fc7b499d5d33f5.png";